import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "type", "in", "timeout", "mountOnEnter", "unmountOnExit"];
import React from 'react';
import CSSTransition from 'react-transition-group/CSSTransition';
import { ContextLayout } from '../context-provider';

/**
 * react-transition-group/CSSTransition 的简单封装。
 * @type 其他
 * @name 动画过渡
 */
export default function Transition(props) {
  var children = props.children,
      type = props.type,
      transIn = props.in,
      timeout = props.timeout,
      _props$mountOnEnter = props.mountOnEnter,
      mountOnEnter = _props$mountOnEnter === void 0 ? true : _props$mountOnEnter,
      _props$unmountOnExit = props.unmountOnExit,
      unmountOnExit = _props$unmountOnExit === void 0 ? true : _props$unmountOnExit,
      restProps = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement(CSSTransition, _extends({
      in: transIn,
      timeout: timeout,
      classNames: prefixCls + "-" + type,
      mountOnEnter: mountOnEnter,
      unmountOnExit: unmountOnExit
    }, restProps), children);
  });
}